/**
 * Formata um número para o formato de moeda brasileira (R$ 1.234,56)
 */
export function formatCurrencyInput(value: string): string {
  // Remove tudo que não é dígito
  const numbers = value.replace(/\D/g, '');
  
  if (!numbers) return '';
  
  // Converte para número e divide por 100 (centavos)
  const amount = parseFloat(numbers) / 100;
  
  // Formata como moeda brasileira
  return amount.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Converte o valor formatado (1.234,56) para número (1234.56)
 */
export function parseCurrencyInput(value: string): number {
  if (!value) return 0;
  
  // Remove tudo que não é dígito ou vírgula
  const cleaned = value.replace(/\./g, '').replace(',', '.');
  const number = parseFloat(cleaned);
  
  return isNaN(number) ? 0 : number;
}

/**
 * Hook para gerenciar input de moeda com formatação
 */
export function useCurrencyInput(initialValue: number = 0) {
  const formatValue = (numValue: number): string => {
    if (numValue === 0) return '';
    return numValue.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return {
    formatValue,
    parseValue: parseCurrencyInput,
  };
}

/**
 * Formata um número para exibição em moeda brasileira (R$ 1.234,56)
 */
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}
